import { render } from "./TournamentTatamis.vue?vue&type=template&id=50e09d4d&scoped=true"
import script from "./TournamentTatamis.vue?vue&type=script&lang=js"
export * from "./TournamentTatamis.vue?vue&type=script&lang=js"

import "./TournamentTatamis.vue?vue&type=style&index=0&id=50e09d4d&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e09d4d"]])

export default __exports__